<template>
    <SubmenuGrid :items="items" :show-count="false" />
</template>

<script>
import SubmenuGrid from "@/components/SubmenuGrid";

export default {
    name: "PortalAdminEduSchoolSubMenuvueSubmenu",
    components: { SubmenuGrid },
    data() {
        return {
            items: [
            {
                to: "/admin/eduschool/school-subjects",
                title: "School Subjects",
                description: "Create and manage the subjects offered by each school.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/eduschool/class-note-setup",
                title: "Class Note",
                description: "Open class notes and learning materials shared by your teachers.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/eduschool/eduschool-exam-prep",
                title: "Exam Prep",
                description: "Organize exam preparation resources and practice activities.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/eduschool/notification-sender",
                title: "Notification Sender",
                description: "Send important updates and announcements to schools.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/exam-setup",
                title: "School Type",
                description: "Manage the school categories used across the platform.",
                icon: "fa fa-folder"
            },
            {
                to: "/school/exam-setup",
                title: "School Level",
                description: "Configure education levels available to schools.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/eduschool/community-setup",
                title: "Community",
                description: "Manage community information and school connections.",
                icon: "fa fa-folder"
            },
            {
                to: "/admin/eduschool/news-setup",
                title: "News",
                description: "Create and manage news and announcements for your audience.",
                icon: "fa fa-folder"
            }
            ]
        };
    }
};
</script>
